import { GraphQLClient } from "graphql-request";
import { graphqlRequestBaseQuery } from "@rtk-query/graphql-request-base-query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";

import { RootState } from "@/store";
import { gqlMockServerURL, gqlServerURL } from "@/config";

export const mockClient: GraphQLClient = new GraphQLClient(gqlMockServerURL);
export const client: GraphQLClient = new GraphQLClient(gqlServerURL);

interface FetchBaseQueryError {
  status: number;
  data: any;
  error?: string;
}

export const baseQuery: BaseQueryFn<
  { document: string; variables?: any },
  any,
  FetchBaseQueryError,
  object,
  object
> = graphqlRequestBaseQuery({
  client,
  prepareHeaders: (headers, { getState, endpoint }) => {
    console.log(`🔍 [GraphQL] Preparing request to GraphQL endpoint`);
    console.log(`🔍 [GraphQL] Endpoint: ${endpoint}`);
    
    const state = getState() as RootState;
    const token = state.auth.accessToken;
    console.log(`🔍 [GraphQL] Auth token present: ${!!token}`);
    
    if (token) {
      headers.set("Authorization", token);
      console.log(`🔍 [GraphQL] Added Authorization header: ${token.substring(0, 20)}...`);
    } else {
      console.warn(`⚠️ [GraphQL] No auth token found in state`);
    }

    console.log(`🔍 [GraphQL] Final headers:`, Object.fromEntries(headers.entries()));
    return headers;
  },
  customErrors: (error) => {
    console.error(`❌ [GraphQL] Error occurred:`, error);
    console.error(`❌ [GraphQL] Error response:`, error.response);
    console.error(`❌ [GraphQL] Error message:`, error.message);
    console.error(`❌ [GraphQL] Error stack:`, error.stack);
    
    if (error.response?.errors) {
      const formattedErrors = error.response.errors
        .map((err) => err.message)
        .join(", ");
      console.error(`❌ [GraphQL] GraphQL errors:`, formattedErrors);
      throw new Error(formattedErrors);
    }
    console.error(`❌ [GraphQL] Network error:`, error.message);
    throw new Error(`Network Error: ${error.message}`);
  },
});

export const baseQueryMock: BaseQueryFn<
  { document: string; variables?: any },
  any,
  FetchBaseQueryError,
  object,
  object
> = graphqlRequestBaseQuery({
  client: mockClient,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const token = state.auth.accessToken;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }

    return headers;
  },
  customErrors: (error) => {
    if (error.response?.errors) {
      const formattedErrors = error.response.errors
        .map((err) => err.message)
        .join(", ");
      throw new Error(formattedErrors);
    }
    throw new Error(`Network Error: ${error.message}`);
  },
});
